/* Copyright (C) Okahu Inc 2023-2024. All rights reserved. */

'use client';

import { useContext } from 'react';
import { ComponentsContext } from '@/context';

export const useComponents = () => {
  return useContext(ComponentsContext);
};
